import { useRef, useState, useContext } from "react";
import { createPortal } from "react-dom";
import { getDailyPosts, updateDailyPost } from "../CommonFunc";
import { AppContext } from "../../Context/AppContext";
import "./EditPost.scss";

function EditPost(props) {
	const { theme } = useContext(AppContext);
	const [dateOffset, setDateOffset] = useState(0);
	const inputRef = useRef();
	const headerRef = useRef();
	const editPost = () => {
		updateDailyPost(
			props.currentDiaryPosts[props.selectedPost].ID_NOTE,
			props.currentDiary.ID,
			headerRef.current.value,
			inputRef.current.value,
			dateOffset
		).then((result) => {
			getDailyPosts(props.currentDiary.ID, 0, 10).then((posts) => {
				props.setCurrentDiaryPosts(posts);
				props.setOpenEditPost(false);
				props.setSelectedPost(null);
			});
		});
	};
	const offsetUpdate = (offset) => {
		setDateOffset((prev) => prev + offset);
	};
	let curr = new Date(
		props.currentDiaryPosts[props.selectedPost]?.DATE_EDIT.split(".")
			.reverse()
			.join("/")
	);
	curr.setDate(curr.getDate() + dateOffset);
	const formatedDate = (date) => {
		const yyyy = date.getFullYear();
		let mm = (date.getMonth() + 1).toString().padStart(2, "0"); // Months start at 0!
		let dd = date.getDate().toString().padStart(2, "0");
		const formated = dd + "." + mm + "." + yyyy;
		return formated;
	};
	let day = curr.getDate();
	let month = curr.getMonth() + 1;
	let year = curr.getFullYear();
	let date = `${year}-${month.toString().padStart(2, "0")}-${day
		.toString()
		.padStart(2, "0")}`;
	let rus = formatedDate(curr);

	return createPortal(
		<div
			className='edit-post-dialog-wrapper'
			color={props.theme.color}
			style={{
				fontSize: `${18 * theme.fontMultiplier}px`,
			}}
		>
			<div className='edit-post-dialog'>
				<div className='content-wrapper'>
					<div className='button-block'>
						<div className='row'>
							<div
								className='close-button'
								onClick={() => props.setOpenEditPost(false)}
							>
								Закрыть
							</div>
							<div className='create-button' onClick={() => editPost()}>
								Сохранить
							</div>
						</div>
						<div className='row'>
							<label>Тема:</label>
							<input
								ref={headerRef}
								className='header-field'
								type='text'
								defaultValue={
									props.currentDiaryPosts[props.selectedPost]?.MNEMO
								}
								autoFocus
							/>
						</div>
						<hr style={{ width: "100%", margin: "0px 0px" }} />
						<div className='row'>
							<label>Дата:</label>
							<div className='date-picker'>
								<div
									className='date-picker-button'
									onClick={() => offsetUpdate(-1)}
								>
									{"<"}
								</div>
								<input
									className='date-picker-input'
									type='date'
									value={date}
									readOnly
								/>
								<div className='date-label'>{rus}</div>
								<div
									className='date-picker-button'
									onClick={() => offsetUpdate(1)}
								>
									{">"}
								</div>
							</div>
						</div>
					</div>
					<hr style={{ width: "100%", margin: "0px 0px" }} />
					<textarea
						ref={inputRef}
						className='name-field'
						type='text'
						placeholder='Текст'
						defaultValue={props.currentDiaryPosts[props.selectedPost]?.CONT_TXT}
					/>
				</div>
			</div>
		</div>,
		document.getElementById("editPost")
	);
}

export default EditPost;
